import React from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import RelatorioStatusCursos from "../components/RelatorioStatusCursos";
const RelatorioStatusCursosPage = () => {
    return (
        <>
            <div className="main-content">
                <Navbar/>
            </div>
            <div className="content">
                <Sidebar/>
            </div>
            <div className='table-status'>
                <RelatorioStatusCursos/>
            </div>
        </>
    );
};

export default RelatorioStatusCursosPage;